export default {
  'Custom': '自定義',
  'Original': '原始',
}